import React from "react";
import { Modal } from "react-bootstrap";
import ProjectCard from "./ProjectCard";

function ProjectModal({show, setShow, data}) {
  return (
    <>
      <Modal
        show={show}
        onHide={() => setShow(false)}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        size="lg" //can change to xl
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            {data.title}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <ProjectCard data={data}/>
        </Modal.Body>

      </Modal>
    </>
  );
}

export default ProjectModal;
